import React, { Component, PropTypes } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		return {
			avatarOptions: avatar && avatar.options ? avatar.options : null,
			step: state.step,
			results: state.results
		}
	}
)
export default class ReviewResults extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
		this.results = this.props.results
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { results } = this;
		const playerAvatar = buildAvatar(this.props, false);

		return (results && results.players) ? (
			<div className={'eco-score-tracker__review'}>

				<EconomicalScoreTrackerPlayer score={results.players['player-1'].resources}
																			imgSrc={playerAvatar} />
				<EconomicalScoreTrackerPlayer score={results.players['player-2'].resources}
																			imgSrc={players['player-2']} />
				<EconomicalScoreTrackerPlayer score={results.players['player-3'].resources}
																			imgSrc={players['player-3']} />
				<EconomicalScoreTrackerPlayer score={results.players['player-4'].resources}
																			imgSrc={players['player-4']} />

			</div>
		) : null;
	}
}
